import { render, staticRenderFns } from "./ImageDetailPopup.vue?vue&type=template&id=67b4de2c&scoped=true&"
import script from "./ImageDetailPopup.vue?vue&type=script&lang=js&"
export * from "./ImageDetailPopup.vue?vue&type=script&lang=js&"
import style0 from "./ImageDetailPopup.vue?vue&type=style&index=0&id=67b4de2c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67b4de2c",
  null
  
)

export default component.exports